import API from "../../api";

const SET_LIST = "SET_LIST";
const SET_PRELOADER = "SET_PRELOADER";
const SET_TOTALS_PAGINATION = "SET_TOTALS_PAGINATION";
const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
const SET_SORT = "SET_SORT";
const SET_SELECTED_CITY = "SET_SELECTED_CITY";
const SET_DISTRICTS = "SET_DISTRICTS";

export default {
  namespaced: true,

  state: {
    list: "",
    selected: {
      id: false,
      districts: []
    },
    pagination: {
      current: 1,
      totalPages: 1,
      totalResults: 1
    },
    sort: "",
    preloader: false
  },

  actions: {
    async index({ state, commit, dispatch }) {
      commit("SET_PRELOADER", true);

      try {
        let results = await API.Cities.index(
          state.pagination.current,
          state.sort
        );

        commit("SET_TOTALS_PAGINATION", results.meta);
        commit("SET_LIST", results.data);
        dispatch("getDistricts");
      } catch (e) {
        throw e;
      }

      commit("SET_PRELOADER", false);
    },

    async listAll() {
      try {
        return await API.Cities.listAll();
      } catch (e) {
        throw e;
      }
    },

    async create({ commit }, data) {
      try {
        await API.Cities.create(data);
        return true;
      } catch (error) {
        throw error;
      }
    },

    setCurrentPage({ commit, dispatch }, page) {
      commit("SET_CURRENT_PAGE", page);
      dispatch("listAll");
    },

    setSort({ commit, dispatch }, payload) {
      commit("SET_SORT", payload);
      dispatch("listAll");
    },

    setSelectedCity({ state, commit, dispatch }, payload) {
      if (state.selected.id === payload) payload = false;
      commit("SET_SELECTED_CITY", payload);
      dispatch("getDistricts");
    },

    async getDistricts({ state, commit }) {
      commit("SET_DISTRICTS", []);

      if (state.selected.id) {
        try {
          let res = await API.Cities.districts(state.selected.id);
          commit("SET_DISTRICTS", res);
        } catch (error) {
          throw error;
        }
      }
    },

    async searchByName({ state }, query) {
      try {
        return await API.Cities.searchByName(query);
      } catch (error) {
        throw error;
      }
    }
  },

  mutations: {
    [SET_LIST](state, payload) {
      state.list = payload;
    },
    [SET_PRELOADER](state, payload) {
      state.preloader = payload;
    },
    [SET_TOTALS_PAGINATION](state, payload) {
      state.pagination.totalPages = payload.page_count;
      state.pagination.totalResults = payload.record_count;
    },
    [SET_CURRENT_PAGE](state, payload) {
      state.pagination.current = payload;
    },
    [SET_SORT](state, payload) {
      state.sort = payload;
    },
    [SET_SELECTED_CITY](state, payload) {
      state.selected.id = payload;
    },
    [SET_DISTRICTS](state, payload) {
      state.selected.districts = payload;
    }
  },

  getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/cities.js